import Vue from "vue"
import Swal from "sweetalert2"
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"
import "@uarizona-fnsv/bootstrap/dist/bootstrap.css"
import Doggo from "vue-doggo"

import App from "./App.vue"
import api from "./utils/api"
import router from "./router"

function getEnvironment() {
  const hostname = window.location.hostname
  if (hostname.includes("-dev")) return "dev"
  if (hostname.includes("cloudfront.net")) return "review"
  return "prod"
}

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    environment: getEnvironment(),
  })
}

Vue.config.productionTip = false

Vue.prototype.$alert = Swal
Vue.prototype.$api = api

Vue.use(Doggo, {
  amplify: {
    region: process.env.VUE_APP_COGNITO_REGION,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    domain: process.env.VUE_APP_COGNITO_DOMAIN,
    redirectSignIn: process.env.VUE_APP_COGNITO_SIGN_IN_URL,
  },
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app")
